<script>
export default {
    name: "WhoNextDepartmentSvg"
}
</script>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="149.038" height="66.359" viewBox="0 0 149.038 66.359">
        <g id="Group_905" data-name="Group 905" transform="translate(-1148.158 -506.943)">
            <g id="Group_904" data-name="Group 904" transform="translate(1148.158 506.943)">
                <text id="next_department" data-name="next
department" transform="translate(0 9)" font-size="12" font-family="Apertura-Medium, Apertura" font-weight="500" letter-spacing="0.1em"><tspan x="0" y="0">next</tspan><tspan x="0" y="14">department</tspan></text>
                <g id="Group_901" data-name="Group 901" transform="translate(0 11.807)">
                    <g id="Polygon_6" data-name="Polygon 6" transform="translate(149.038 0) rotate(90)" fill="none">
                        <path d="M27.276,0,54.552,46.369H0Z" stroke="none"/>
                        <path d="M 27.27605819702148 1.972297668457031 L 1.748409271240234 45.36929702758789 L 52.80370712280273 45.36929702758789 L 27.27605819702148 1.972297668457031 M 27.27605819702148 0 L 54.55211639404297 46.36929702758789 L 0 46.36929702758789 L 27.27605819702148 0 Z" stroke="none" fill="#000"/>
                    </g>
                    <path id="Path_278" data-name="Path 278" d="M147.674,0H0" transform="translate(0 27.276)" fill="none" stroke="#000" stroke-width="1"/>
                </g>
            </g>
        </g>
    </svg>
</template>
